<template>
  <div class="c-empty-content">
    <img src="../images/data_empty.png" alt="">
    <p>暂无数据~</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyContent',
};
</script>

<style lang="scss" scoped>
.c-empty-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 70px;
  img {
    width: 160px;
  }
  p {
    margin-top: 12px;
    font-size: 14px;
    color: rgba(17, 31, 44, 0.6);
  }
}
</style>
